export const storageKeys = {
  EXP3_SETTINGS: 'EXP3_SETTINGS',
}
